
    import {Component, Prop, Vue} from 'vue-property-decorator'
    import {callPhone} from "@/utils/h5ToApp";
    import {ServiceLineListDto} from "@/api/commonConfig";

    @Component({
        name: 'ServiceLine',
    })
    export default class ServiceLine extends Vue {
        @Prop({ default: () => {return []} }) list!: ServiceLineListDto[];
        showTemp = false

        toCall (phone: string) {
            callPhone({ tel: phone })
        }

        show () {
            this.showTemp = true
        }
    }
